import {
  Mail,
  FileText,
  PackageCheck,
  Factory,
  ClipboardCheck,
  Ship,
} from "lucide-react";
import { processSteps } from "@/data/site";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

const iconMap = {
  Mail,
  FileText,
  PackageCheck,
  Factory,
  ClipboardCheck,
  Ship,
};

export default function ExportProcess() {
  return (
    <section
      id="process"
      data-testid={IDS.processSection}
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
            Export Process
          </span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-[1.08] tracking-tight text-ink">
            From enquiry to your port — in{" "}
            <span className="font-serif-accent italic font-medium text-brand">
              six clear steps.
            </span>
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          {/* dashed horizontal line - desktop only */}
          <div className="hidden lg:block absolute left-8 right-8 top-8 timeline-dash" />

          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-4 relative">
            {processSteps.map((s, i) => {
              const Icon = iconMap[s.icon];
              return (
                <li key={s.title} className="relative">
                  <Reveal delay={i * 0.08}>
                    <div className="group flex flex-col items-start">
                      <div className="relative inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-brand group-hover:bg-forest text-white shadow-lg shadow-brand/20 transition-colors duration-500">
                        <Icon className="h-7 w-7" strokeWidth={1.7} />
                        <span className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-white text-forest font-heading font-bold text-xs flex items-center justify-center border border-line shadow-sm">
                          {i + 1}
                        </span>
                      </div>
                      <h3 className="mt-6 font-heading font-semibold text-base leading-tight text-ink">
                        {s.title}
                      </h3>
                      <p className="mt-2 text-sm text-mist leading-relaxed">
                        {s.body}
                      </p>
                    </div>
                  </Reveal>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
